import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de parametría de campos de trabajadores
 */
export const parametriaCamposTrabajadoresApi = {
  /**
   * Obtener todos los campos de parametría
   * @param {number|null} proyectoId - ID del proyecto (opcional)
   * @param {number|null} clienteId - ID del cliente (opcional)
   * @param {boolean|null} activo - Filtrar por activo (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: (proyectoId = null, clienteId = null, activo = null) => {
    const params = new URLSearchParams();
    if (proyectoId) params.append('proyecto_id', proyectoId);
    if (clienteId) params.append('cliente_id', clienteId);
    if (activo !== null) params.append('activo', activo);
    
    return pythonApiClient.get(`/mantenimientos/parametria-campos-trabajadores?${params.toString()}`);
  },

  /**
   * Obtener solo campos activos
   * @param {number|null} proyectoId - ID del proyecto (opcional)
   * @param {number|null} clienteId - ID del cliente (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getActivos: (proyectoId = null, clienteId = null) => {
    const params = new URLSearchParams();
    if (proyectoId) params.append('proyecto_id', proyectoId);
    if (clienteId) params.append('cliente_id', clienteId);
    
    return pythonApiClient.get(`/mantenimientos/parametria-campos-trabajadores/activos?${params.toString()}`);
  },

  /**
   * Obtener columnas para template Excel
   * @param {number|null} proyectoId - ID del proyecto (opcional)
   * @param {number|null} clienteId - ID del cliente (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getTemplateColumns: (proyectoId = null, clienteId = null) => {
    const params = new URLSearchParams();
    if (proyectoId) params.append('proyecto_id', proyectoId);
    if (clienteId) params.append('cliente_id', clienteId);
    
    return pythonApiClient.get(`/mantenimientos/parametria-campos-trabajadores/template-columns?${params.toString()}`);
  },

  /**
   * Obtener campo por ID
   * @param {number} campoId - ID del campo
   * @returns {Promise} - Respuesta de la API
   */
  getById: (campoId) => {
    return pythonApiClient.get(`/mantenimientos/parametria-campos-trabajadores/${campoId}`);
  },

  /**
   * Crear nuevo campo
   * @param {Object} campoData - Datos del campo
   * @returns {Promise} - Respuesta de la API
   */
  create: (campoData) => {
    return pythonApiClient.post('/mantenimientos/parametria-campos-trabajadores', campoData);
  },

  /**
   * Actualizar campo
   * @param {number} campoId - ID del campo
   * @param {Object} campoData - Datos del campo a actualizar
   * @returns {Promise} - Respuesta de la API
   */
  update: (campoId, campoData) => {
    return pythonApiClient.put(`/mantenimientos/parametria-campos-trabajadores/${campoId}`, campoData);
  },

  /**
   * Activar/desactivar campo
   * @param {number} campoId - ID del campo
   * @param {boolean} activo - Estado activo
   * @returns {Promise} - Respuesta de la API
   */
  toggleActivo: (campoId, activo) => {
    return pythonApiClient.patch(`/mantenimientos/parametria-campos-trabajadores/${campoId}/toggle-activo?activo=${activo}`);
  },

  /**
   * Eliminar campo
   * @param {number} campoId - ID del campo
   * @returns {Promise} - Respuesta de la API
   */
  delete: (campoId) => {
    return pythonApiClient.delete(`/mantenimientos/parametria-campos-trabajadores/${campoId}`);
  },
};

export default parametriaCamposTrabajadoresApi;
